import React from "react"
import cx from "classnames"
import { confirm } from "@kit/design/modal"

export const appFont =
  '"Open Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"'

function RadioButton({ onChange, label, name, value, active, icon, ...props }) {
  const handleChange = () => {
    onChange({ target: { name, value } })
  }

  const transition = "transition-colors duration-300 ease-in-out"
  const className = cx(
    "flex rounded-sm leading-none px-1 text-center cursor-pointer",
    transition,
    {
      "bg-blue-600 text-white": active
    }
  )

  const id = `${name}-${value}`

  return (
    <label
      className={className}
      htmlFor={id}
      style={{ marginBottom: 0, padding: "6px 8px" }}
    >
      <input
        id={id}
        className="appearance-none hide"
        style={{ padding: 6, minWidth: 26 }}
        onChange={handleChange}
        aria-label={props["aria-label"]}
        name={name}
        value={value}
        checked={active}
        type="radio"
      />
      {icon || label}
    </label>
  )
}

export function RadioButtonGroup({
  keyName,
  name,
  value,
  options,
  update,
  properties,
  onChange,
  ...props
}) {
  return (
    <div
      className="w-full flex space-between bg-gray-100 rounded justify-evenly"
      style={{ padding: 6 }}
      {...props}
    >
      {options.map(option => {
        return (
          <RadioButton
            key={option.value}
            {...option}
            name={name}
            onChange={onChange}
            active={option.value === value}
          />
        )
      })}
    </div>
  )
}

export const handleDelete = async (block_id, remove, block_type) => {
  const confirmedDelete = await confirm(
    `Are you sure you want to delete this ${block_type}?`,
    {
      message: "This action cannot be undone.",
      cancel: "Cancel",
      confirm: "Delete"
    }
  )

  if (confirmedDelete) {
    remove(block_id)
  }
}

const ASPECT_RATIOS = {
  landscape: "16:9",
  portrait: "3:4",
  square: "1:1"
}

export const getSource = (src, { crop }) => {
  const url = new URL(src)

  if (ASPECT_RATIOS[crop]) {
    url.searchParams.set("ar", ASPECT_RATIOS[crop])
    url.searchParams.set("fit", "crop")
  }

  return url.toString()
}
